<div class="stepper" [class.stepper-disabled]="disabled()" [attr.aria-label]="ariaLabel()">
  <button
    type="button"
    mat-icon-button
    class="stepper-btn"
    (click)="decrement()"
    [disabled]="!showRemove() && !canDecrement()"
    [attr.aria-label]="showRemove() ? 'Entfernen' : 'Verringern'"
  >
    <mat-icon>{{ showRemove() ? 'delete' : 'remove' }}</mat-icon>
  </button>
  <span class="stepper-value mat-body-medium" aria-live="polite">{{ value() }}{{ einheit() ? ' ' + einheit() : '' }}</span>
  <button type="button" mat-icon-button class="stepper-btn" (click)="increment()" [disabled]="!canIncrement()" aria-label="Erhöhen">
    <mat-icon>add</mat-icon>
  </button>
</div>
